module.exports = __webpack_public_path__ + "img/tabletlinyun.519f8c58.png";